import Head from 'next/head'
import { FunctionComponent } from 'react'
import { isLoggedIn } from '@/utils/lib'
import { Header } from '../../misc/Header'
import { Footer } from '../../misc/Footer'

interface Props {
  withHeader?: boolean
}

export const NotFound: FunctionComponent<Props> = ({ withHeader }) => {
  const header = typeof withHeader === 'undefined' ? true : withHeader
  return (
    <div className="flex flex-col justify-between gap-5 h-screen">
      <Head>
        <title>Page Not found - Qureos</title>
      </Head>
      {header && <Header loggedIn={isLoggedIn()} />}
      <div className="w-1/2 bg-white p-8 rounded-lg shadow mx-auto">
        <h1 className="mb-4 text-center">Error 404</h1>
        <div className="text-base text-center">
          Seems you&apos;re too <span className="text-qureosBlue">Qureos</span>{' '}
          and you got lost? No worries, you can navigate back!
        </div>
      </div>

      <Footer />
    </div>
  )
}
